import type { Select } from "antd"

type FormChangeProps = {
  form: string,
  input: {
    name: string,
    value: string
  }
}

/**
 * Split input out of its form, returning form name and input meta properly
 * 
 * @param ev 
 * @returns {FormChangeProps}
 */
export const onFormChange = (ev: any): FormChangeProps => {
  const { nativeEvent, target } = ev
  const { path } = nativeEvent
  
  const form = path?.find((p: any) => p.tagName === 'FORM')

  // Slice out the form name from input name
  const realInputName = form && target?.id?.replace(`${form.id}_`, '')

  return {
    form: form?.id,
    input: {
      name: realInputName,
      value: target?.value
    }
  }
}

/**
 * Default select filterOption implementation. Allow to search options in antd <Select />
 * 
 * @example
 * <Select
 *    showSearch={true}
 *    filterOptions={DEFAULT_SELECT_FILTER_OPTION}
 *    options={options}
 * />
 */
export const DEFAULT_SELECT_FILTER_OPTION: Parameters<typeof Select>[number]["filterOption"] = (input, option) => {
  if (!option?.label || typeof option.label !== 'string') return false

  return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
}